/**
 * Validate value if it US zip code
 * @param  string
 *
 * @returns {boolean}
 */
export default (value) => /(^\d{5}$)|(^\d{5}-\d{4}$)/.test(value);
